import { render, staticRenderFns } from "./feedbackOrder.vue?vue&type=template&id=596818a7&"
import script from "./feedbackOrder.vue?vue&type=script&lang=js&"
export * from "./feedbackOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports